export const REVIEWS_STATE = 'reviews'

export const FETCH_REVIEWS_REQUEST = 'FETCH_REVIEWS_REQUEST'
export const FETCH_REVIEWS_SUCCESS = 'FETCH_REVIEWS_SUCCESS'
export const FETCH_REVIEWS_FAILURE = 'FETCH_REVIEWS_FAILURE'
export const SET_REVIEWS_FILTER = 'SET_REVIEWS_FILTER'

export type TripReasonFilter =
  | 'business'
  | 'leisure'
  | 'business_and_leisure'
  | 'friends_and_family'
